import { useErrorHandler } from 'feature/appeals/hooks/useErrorHandler'
import { newAppealState } from 'feature/appeals/redux/appealFormCreateSelector'
import { useAppealManagerMutation } from 'feature/appeals/redux/appeals.api'
import { TAppealManagerRequest } from 'feature/appeals/type'
import { useSetNotice } from 'hooks/useSetNotice'
import { FieldValues, SubmitHandler } from 'react-hook-form'
import { useAppSelector } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { OrderManageFrom } from '../OrderManageFrom/OrderManageFrom'

type TMainOrderManage = {
  handleBack: () => void
  title: string
  description: string
  subtitle?: string
  textFieldLabel: string
  onSubmit?: SubmitHandler<FieldValues>
  isLoading?: boolean
  onClose: () => void
  requestType: 'cancel' | 'make-complaint-dealer'
}

// обертка для формы отмены заявки и жалобы на диллера

export function OrderManageFormContainer({
  handleBack,
  title,
  description,
  textFieldLabel,
  subtitle,
  requestType,
  onClose,
}: TMainOrderManage) {
  const [appealManager, { isLoading }] = useAppealManagerMutation()
  const { uid, orderId } = useAppSelector(newAppealState)

  const setNotice = useSetNotice()
  const errorHandler = useErrorHandler()

  const onSubmit: SubmitHandler<FieldValues> = values => {
    const requestBody: TAppealManagerRequest = {
      url: requestType,
      uid,
      orderId,
      comment: values.comment,
    }

    appealManager(requestBody)
      .then(res => {
        if ('error' in res) {
          //@ts-ignore
          const error = res.error.data
          errorHandler(error)
          if (error.code === 422) onClose()
          return
        }
        onClose()
        setNotice('Заявка успешно отправлена', Severity.success)
      })
      .catch(error => {
        errorHandler(error)
        if (error.code === 422) onClose()
      })
  }

  return (
    <OrderManageFrom
      handleBack={handleBack}
      title={title}
      description={description}
      textFieldLabel={textFieldLabel}
      onSubmit={onSubmit}
      isLoading={isLoading}
      subtitle={subtitle}
    />
  )
}
